import React, { useState, useEffect, useContext,useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { BsCalendar, BsClock } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdArrowBack } from "react-icons/md";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { getRole } from "../../components/Apicall";
import { RiGraduationCapLine } from "react-icons/ri";
import { RiStethoscopeLine } from "react-icons/ri";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import UserContext from "../../components/context/UserContext";
import { Formik } from "formik";
import * as Yup from "yup";
import { IoCalendarOutline } from "react-icons/io5";
import ProviderAvailability from "./ProviderAvailability";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import EditProfileSidebar from "./EditProfileSidebar";
import { getPersonaForRole, PERSONA } from "../../constants/roles";

const ProviderProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const openEditProfile = location.state?.openEditProfile;
   const servicePrefix = location.state?.serviceNames || "";
  const onProfileUpdate = location.state?.onProfileUpdate;
  const industry = location.state?.industry;
    const [doctorData, setDoctorData] = useState(location.state?.doctorData);
  // Crew persona: own profile only - block navigation into a coworker's
  // profile (e.g. from a booking's assigned-crew link) even though the
  // main Crew list already only shows their own card. A useEffect (not an
  // early return) so every hook below still runs on every render.
  const isCrewUser = getPersonaForRole(getRole()) === PERSONA.CREW;
  const currentUserId = localStorage.getItem("userId");
  // service_provider (not user_id - get_ezp_service_providers never returns
  // that column) holds the crew member's own ezp_users.id, whether doctorData
  // came from Providers.jsx's navigation state or this page's own refetch.
  useEffect(() => {
    if (isCrewUser && doctorData?.service_provider && String(doctorData.service_provider) !== String(currentUserId)) {
      navigate("/access-denied");
    }
  }, [isCrewUser, doctorData?.service_provider, currentUserId]);

const [isActive, setIsActive] = useState(doctorData?.is_active === 1);
  const [showEditSidebar, setShowEditSidebar] = useState();
  // Employee Management's "Edit" action for a Crew row navigates here with
  // openEditProfile: true so the user lands in edit mode directly, not just
  // on the read-only profile view.
  useEffect(() => {
    if (openEditProfile) setShowEditSidebar(true);
  }, [openEditProfile]);
  const [crewBookings, setCrewBookings] = useState([]);
  const [isAvailable, setIsAvailable] = useState(true);
  const [showAvailabilityOptions, setShowAvailabilityOptions] = useState(false);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [savedDate, setSavedDate] = useState(null);
  const [savedTime, setSavedTime] = useState(null);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [summaryText, setSummaryText] = useState("");
  const [selectedStartTime, setSelectedStartTime] = useState([]);
  const [calendarRange, setCalendarRange] = useState([null, null]);
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [isAppointmentCance, setIsAppointmentCancel] = useState(false);
  const [bookingIds, setBookingIds] = useState([]);
  const [bookingTimes, setBookingTimes] = useState([]);
  const [bookingObject, setBookingObject] = useState([]);
  const [optionSelected, setOptionSelected] = useState("");
  const vendorIdFromStorage = localStorage.getItem("vendorId");
  const _ud = (() => {
    try {
      const d = localStorage.getItem("userDetails");
      return d && d !== "undefined" ? JSON.parse(d) : null;
    } catch { return null; }
  })();
  const isCarService = _ud?.industry === 8;
  const [scheduleType, setScheduleType] = useState("");
  const startDate = new Date(calendarRange[0]);
  const endDate = new Date(calendarRange[1]);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const { vendor } = useContext(UserContext);
  const [serviceId, setServiceId] = useState("");
  const [specializations, setSpecializations] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [feeRange, setFeeRange] = useState({ fee_from: "", fee_to: "" });
const [showHolidayModal, setShowHolidayModal] = useState(false);
const [holidayRange, setHolidayRange] = useState([null, null]);

  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const formattedStartDate = formatDateLocal(startDate);
  const formattedEndDate = formatDateLocal(endDate);

  // console.log("doctorData-----", doctorData);
const calendarRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  //function to convert date to 12 hours
  const convertTo12Hr = (time24) => {
    const [hour, minute] = time24.split(":");
    const hourNum = parseInt(hour);
    const period = hourNum >= 12 ? "PM" : "AM";
    const hour12 = hourNum % 12 || 12;
    return `${hour12}:${minute} ${period}`;
  };

  useEffect(() => {
    const role = getRole();
    setUserRole(role);
  }, []);

  useEffect(() => {
    if (vendor && vendor.service) {
      setServiceId(vendor.service);
    }
  }, [vendor]);

  useEffect(() => {
    if (vendor) {
      setFeeRange({
        fee_from: vendor.fee_from || "",
        fee_to: vendor.fee_to || "",
      });
    } else {
      setFeeRange({ fee_from: "", fee_to: "" });
    }
  }, [vendor]);

  useEffect(() => {
    if (serviceId) {
      fetchSpecializations();
      fetchEducationOptions();
    }
  }, [serviceId]);

  const fetchSpecializations = async () => {
    try {
      const response = await apicall.get(`get_service_offerings/${serviceId}`);
      if (response.status === 200) {
        setSpecializations(response.data);
      }
    } catch (error) {
      console.error("Error fetching specializations:", error);
    }
  };

  const fetchEducationOptions = async () => {
    try {
      const response = await apicall.get(
        `serviceProviderEducation/${serviceId}`
      );
      if (response && response.data) {
        setEducationOptions(response.data);
      }
    } catch (error) {
      console.error("Error fetching education options:", error);
    }
  };

  const selectedTimeStrings = selectedStartTime.map((item) => item.timeString);

  const filteredBookedSlots =
    bookingObject.length !== 0
      ? bookingObject.filter((b) =>
          selectedTimeStrings.includes(convertTo12Hr(b.service_time))
        )
      : [];

  let handleBack;
  if (userRole === "3") {
    handleBack = () => navigate("/providers");
  } else {
    handleBack = () => navigate("/users");
  }
  const handleAvailabilityToggle = () => {
    if (isAvailable) {
      setShowAvailabilityOptions(true);
    }
    setIsAvailable(!isAvailable);
  };

  //function call get dates of the holiday from particular start date to the end date
  const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    const getDatePart = (dateStr) => dateStr.split(" ")[0];
    const start = new Date(`${getDatePart(startDate)}T00:00:00Z`);
    const end = new Date(`${getDatePart(endDate)}T00:00:00Z`);

    const current = new Date(start);

    while (current <= end) {
      // Format as YYYY-MM-DD
      const dateStr = current.toISOString().split("T")[0];
      dates.push(dateStr);
      current.setUTCDate(current.getUTCDate() + 1);
    }

    return dates;
  };
const fetchDoctorHolidays = async () => {
  try {
    const response = await apicall.get(
      `get_holidays?user_id=${doctorData?.id}`
    );
         setUnavailableDates(response.data);


  } catch (error) {
    console.error("Error fetching doctor holidays:", error);
    toast.error("Failed to fetch doctor holidays");
  }
};
  //function call to call providers leaves
//   const fetchDoctorHolidays = async (doctorId) => {
//     try {
//       const response = await apicall.get(`get_holidays?user_id=${doctorId}`);
// // console.log(response,"response")
//       if (response.status === 200) {
//         if (response.data.length > 0) {
//           const allUnavailableDates = response.data.flatMap((holiday) =>
//             getDatesInRange(holiday.holiday_start, holiday.holiday_end)
//           );
//           const uniqueUnavailableDates = [...new Set(allUnavailableDates)];
//           setUnavailableDates(uniqueUnavailableDates);
//         } else {
//           setUnavailableDates([]);
//         }
//       } else {
//         toast.error("Failed to fetch doctor holidays");
//       }
//     } catch (error) {
//       console.error("Error fetching doctor holidays:", error);
//       toast.error("Failed to fetch doctor holidays");
//     }
//   };

  //function call to call the holiday api
  const handleHolidayApi = async () => {
    const holidayReqBody = {
      user_id: doctorData?.id,
      holiday_start: formattedStartDate + "T00:00:00",
      holiday_end: formattedEndDate + "T23:59:59",
      created_by: doctorData?.id,
    };

    try {
      const holidayRes = await apicall.post(holidayReqBody, "add_holiday");
      if (holidayRes.status === 200) {
        toast.success("Holiday updated successfully");
      } else {
        toast.error("Failed to update holiday");
      }
    } catch (holidayError) {
      console.error("Error in holiday API:", holidayError);
      toast.error("Failed to update holiday");
    }
  };

  //function  call to handle reschedule the appointment
  const handleRescheduleAppointment = async () => {
    const payload = {
      service_provider: doctorData?.id,
      ...(scheduleType &&
        scheduleType !== "date" && {
          reschedule_type: scheduleType,
        }),
      bookings: filteredBookedSlots,
      ...(scheduleType === "date" && {
        reschedule_type: "range",
        start_date: formattedStartDate,
        end_date: formattedStartDate,
      }),
    };
    try {
      const response = await apicall.post(payload, "updateMultipleBookings");
      if (response.status === 200) {
        toast.success("Appointments rescheduled successfully");
        setOptionSelected("");
        // handleHolidayApi()
        // Optionally clear any state or UI feedback here
      } else {
        toast.error("Failed to reschedule appointments");
      }
    } catch (error) {
      console.error("Error in Appointment reschedule:", error);
      toast.error("Failed to reschedule appointments");
    }
  };

  //function call to handle Cancel appointment
  const handleCancelAppointment = async () => {
    const payload = {
      service_provider: doctorData?.id,
      status: 14,
      bookings: bookingIds,
    };

    try {
      const cancelRes = await apicall.post(payload, "updateMultipleBookings");
      if (cancelRes.status === 200) {
        toast.success("Appointments cancelled successfully");
        setOptionSelected("");
        setSavedDate(null);
        handleHolidayApi();
      } else {
        toast.error("Failed to cancel appointments");
      }
    } catch (cancelError) {
      console.error("Error in cancelling appointments:", cancelError);
      toast.error("Failed to cancel appointments");
    }
  };

  // useEffect(() => {
  //   if (doctorData) {
  //     fetchBookingData();
  //     fetchDoctorHolidays(doctorData?.id);
  //   }
  // }, [calendarRange]);

  useEffect(() => {
  if (doctorData && calendarRange[0] && calendarRange[1]) {
    fetchBookingData();
  }
  fetchDoctorHolidays(doctorData?.id);

}, [calendarRange, doctorData]);
  //function call to get booking data
  const fetchBookingData = async () => {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_booking_details/range/${formattedStartDate}/${formattedEndDate}/${vendorIdFromStorage}?doctor_id=${doctorData?.id}`
      );

      if (response.status === 200) {
        const filteredResponse = response.data.filter(
          (item) => item.status !== 14
        );

        const bookingsWithDateTime = filteredResponse.map((item) => ({
          id: item.id,
          service_time: item.booking_time,
          service_date: item.booking_date,
          no_of_slots: item.no_of_slots,
          original_time: item.booking_time,
        }));

        setBookingObject(bookingsWithDateTime);

        // Create time slots with date information
        const timeSlots = filteredResponse.map((item) => {
          const [hour, minute] = item.booking_time.split(":");
          const h = parseInt(hour, 10);
          const period = h >= 12 ? "PM" : "AM";
          const formattedHour = h % 12 === 0 ? 12 : h % 12;
          return {
            timeString: `${formattedHour}:${minute} ${period}`,
            date: item.booking_date,
            originalTime: item.booking_time,
            id: item.id,
          };
        });

        setBookingTimes(timeSlots);
        setBookingIds(filteredResponse.map((item) => ({ id: item.id })));
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      toast.error("Failed to fetch booking data");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setShowAvailabilityOptions(true);
    setSelectedDate(savedDate?.toLocaleDateString() || "");
    setSelectedTime(savedTime);
  };

  const handleSelect = () => {
    setShowDateDropdown(!showDateDropdown);
    setShowCalendar(false);
    setShowTimeDropdown(false);
  };

  //fucnction call to set date with out calendar for today and tomorrow
  const handleQuickSelect = (type) => {
    const today = new Date();
    let startDate, endDate;

    if (type === "today") {
      startDate = new Date(today.setHours(0, 0, 0, 0));
      endDate = new Date(today.setHours(23, 59, 59, 999));
    } else if (type === "tomorrow") {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      startDate = new Date(tomorrow.setHours(0, 0, 0, 0));
      endDate = new Date(tomorrow.setHours(23, 59, 59, 999));
    }

    setCalendarRange([startDate, endDate]);
    setShowCalendar(false);
    setShowTimeDropdown(true);
    setRescheduleDate(startDate);

    let summary = selectedDate;
    summary += ` | Rescheduled: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    setSummaryText(summary);
  };

  //function call to select date type today or tomorrow
  const handleDateSelect = (label) => {
    setSelectedDate(label);
    setShowDateDropdown(false);
    setShowFloatingMenu(true);
    setShowCalendar(false);
    if (label === "Today") {
      setScheduleType("today");
      handleQuickSelect("today");
      setShowCalendar(false);
    } else if (label === "Tomorrow") {
      setScheduleType("tomorrow");
      const tomorrow = new Date();
      handleQuickSelect("tomorrow");
      tomorrow.setDate(tomorrow.getDate() + 1);
      setShowCalendar(false);
    } else {
      setScheduleType("date");
      setShowCalendar(true);
    }
  };

  //function call to handle schedule date dropdown
  const handleRescheduleSelect = (action) => {
    setShowFloatingMenu(false);
    if (action === "reschedule") {
      setOptionSelected("reschedule");
      if (scheduleType === "today" || scheduleType === "tomorrow") {
        setShowCalendar(false);
      } else {
        setShowCalendar(true);
      }
    } else {
      if (scheduleType === "today" || scheduleType === "tomorrow") {
        setShowCalendar(false);
      } else {
        setShowCalendar(true);
      }
      setOptionSelected("cancel");
      setShowFloatingMenu(false);
      setIsAppointmentCancel(true);
    }

    setShowTimeDropdown(false);
  };

  //function call to select date range from calendar
  const handleCalendarRangeSelect = (dates) => {
    const [start, end] = dates;
    setCalendarRange([start, end]);
    if (start && end) {
      setShowCalendar(false);
      setShowTimeDropdown(true);
      setRescheduleDate(start);
      let summary = selectedDate;
      summary += ` | Rescheduled: ${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
      setSummaryText(summary);
    }
  };

  //function call to select the slot time
  const handleTimeSelect = (slot) => {
    setSelectedStartTime((prevSelected) => {
      const selected = Array.isArray(prevSelected) ? [...prevSelected] : [];
      const existingIndex = selected.findIndex((s) => s.id === slot.id);

      if (existingIndex > -1) {
        selected.splice(existingIndex, 1);
      } else {
        selected.push(slot);
      }

      return selected;
    });
  };

  //function call on click of save
  const handleSave = async () => {
    setShowAvailabilityOptions(false);
    setShowDateDropdown(false);
    setShowCalendar(false);
    setShowTimeDropdown(false);
    setIsEditing(false);

    try {
      if (isAppointmentCance && optionSelected === "cancel") {
        if (bookingTimes.length !== 0) {
          await handleCancelAppointment();
        }
        await handleHolidayApi();
      }

      if (optionSelected === "reschedule") {
        await handleHolidayApi();
        if (bookingTimes.length !== 0) {
          await handleRescheduleAppointment();
        }
      }
    } catch (error) {
      console.error("Error in handleSave:", error);
      toast.error("Failed to complete the operation");
    }
  };

  //function call on click of cancel
  const handleCancel = () => {
    setShowAvailabilityOptions(false);
    setIsAvailable(true);
    setSavedDate(null);
    setShowDateDropdown(false);
    setShowCalendar(false);
    setShowTimeDropdown(false);
    setSelectedDate("");
    setSummaryText("");
    setBookingTimes([]);
    setSelectedStartTime([]);
    setRescheduleDate(null);
    setSelectedTime(null);
    setIsEditing(false);
  };

  const CustomDropdownToggle = React.forwardRef(
    ({ children, onClick }, ref) => (
      <Button
        ref={ref}
        variant="outline-secondary"
        size="sm"
        className="d-flex align-items-center gap-1"
        onClick={onClick}
        style={{ fontSize: "14px", height: "32px", borderRadius: "4px" }}
      >
        {children || "Select"}
        {children === "Select Time" ? <BsClock /> : <BsCalendar />}
      </Button>
    )
  );
const formatLocalDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
};
  const dateOptions = ["Today", "Tomorrow", "Select Date"];
const fetchCrewBookingsByDate = async (date) => {
  try {
    const res = await apicall.get(`get_ezp_booking?date=${date}`);

    // Filter only this crew
    const filtered = res.data.filter((item) => {
      const providers = item.provider_names
        ?.split(",")
        .map((p) => p.trim());

      return providers?.includes(doctorData?.name); // or id if available
    });

    setCrewBookings(filtered);
  } catch (err) {
    console.error(err);
  }
};
const bookedDates = crewBookings.map((b) => {
  const [year, month, day] = b.service_date.split(" ")[0].split("-");

  return new Date(year, month - 1, day); // LOCAL date (no shift)
});
// const handleSaveHoliday = () => {
//   if (crewBookings.length > 0) {
//     const confirm = window.confirm(
//       "This crew has bookings on selected date. Continue?"
//     );

//     if (!confirm) return;
//   }

//   handleHolidayApi();
// };

const handleToggleStatus = async (value) => {
  try {
    // optimistic UI update
    setIsActive(value);

    const payload = {
      user_id: doctorData?.id,
      is_active: value ? 1 : 0,
    };

    const res = await apicall.post(payload, "update_isActive");

    if (res?.success || res?.status === 200) {
      setIsActive(value);

      setDoctorData((prev) => ({
        ...prev,
        is_active: value ? 1 : 0,
      }));

 toast.success(
        `Status updated to ${value ? "Active" : "Inactive"}`
      );
        } else {
      throw new Error("API failed");
    }
  } catch (error) {
    console.log("Status update failed", error);

    // rollback UI
    setIsActive((prev) => !prev);
    toast.error("Failed to update status");
  }
};
  const getRandomColor = () => {
    const colors = [
      "#FFE4E1",
      "#E6E6FA",
      "#F0FFF0",
      "#F0F8FF",
      "#FFF0F5",
      "#F5F5DC",
      "#E0FFFF",
      "#FFE4B5",
      "#F0FFFF",
      "#F8F8FF",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : "D";
  };

  const fetchDoctorById = async (doctorId) => {
    const response = await apicall.get(
      `get_ezp_service_providers?user_id=${doctorId}`
    );
    if (response && response.status === 200 && Array.isArray(response.data)) {
      const doc = response.data[0];
      if (!doc) return null;
      let genderValue = "2";
      if (doc.gender === 1 || doc.gender === "1" || doc.gender === "Male")
        genderValue = "1";
      if (doc.gender === 2 || doc.gender === "2" || doc.gender === "Female")
        genderValue = "2";
      return {
        ...doc,
        gender: genderValue,
        name: `${doc.first_name || ""} ${doc.last_name || ""}`.trim(),
        specialization: doc.specilisation_name || doc.specialization,
        specialization_id: doc.specilisation_id || doc.specilisation,
        rating: doc.average_rating ?? 0,
        experience: doc.practice_start && !isNaN(new Date(doc.practice_start).getTime())
          ? `${
              new Date().getFullYear() -
              new Date(doc.practice_start).getFullYear()
            } Years Experience`
          : "",
        reviews: doc.total_bookings ?? 0,
      };
    }
    return null;
  };

  // Fetch fresh profile data on every mount (including after window.location.reload()).
  // location.state.doctorData is stale navigation data — the API call always reflects
  // the latest saved values.
  useEffect(() => {
    const initialId = location.state?.doctorData?.id;
    if (!initialId) return;
    fetchDoctorById(initialId).then((fresh) => {
      if (fresh) setDoctorData(fresh);
    });
  }, []);

const handleSaveHoliday = async () => {
  let [start, end] = holidayRange;

  if (!start) {
    toast.error("Please select at least one date");
    return;
  }

  if (!end) {
    end = start;
  }

  const payload = {
    user_id: doctorData?.id,
    holiday_start: start.toISOString().split("T")[0],
    holiday_end: end.toISOString().split("T")[0],
  };

  try {
    const res = await apicall.post(payload, "add_provider_holiday");

    if (res.success) {
      toast.success("Holiday added successfully");
      setHolidayRange([null, null]);
      fetchDoctorHolidays();
    } else {
      toast.error(res.message);
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to add holiday");
  }
};
const getAllDatesInRange = (start, end) => {
  const dates = [];
  let current = new Date(start);
  const last = new Date(end);

  while (current <= last) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return dates;
};
const unavailableDatesObj = unavailableDates?.map(item => new Date(item.date));
  return (
    <div
      style={{
        backgroundColor: "#F2F5FA",
        minHeight: "100vh",
        padding: "24px",
      }}
    >
      <button
        onClick={handleBack}
        className="d-flex align-items-center border-0 bg-transparent mb-3"
        style={{ fontSize: "14px", color: "#212529", padding: 0 }}
      >
        <MdArrowBack size={20} /> BACK
      </button>

      <div className="bg-white rounded-3 p-4 mb-4">
        <div className="d-flex gap-4">
          {doctorData?.profile_image ? (
            <img
              src={doctorData?.profile_image}
              alt={doctorData?.name}
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={() => setShowEditSidebar(true)}
              onError={(e) => {
                const div = document.createElement("div");
                div.style.width = "80px";
                div.style.height = "80px";
                div.style.borderRadius = "50%";
                div.style.backgroundColor = getRandomColor();
                div.style.display = "flex";
                div.style.alignItems = "center";
                div.style.justifyContent = "center";
                div.style.fontSize = "32px";
                div.style.color = "#666666";
                div.style.fontWeight = "bold";
                div.style.cursor = "pointer";
                div.textContent = getInitials(doctorData?.name);
                div.onclick = () => setShowEditSidebar(true);
                e.target.parentNode.replaceChild(div, e.target);
              }}
            />
          ) : (
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: getRandomColor(),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                color: "#666666",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => setShowEditSidebar(true)}
            >
              {getInitials(doctorData?.name)}
            </div>
          )}

          <div className="flex-grow-1">
            <h4
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "4px",
              }}
            >
              {servicePrefix || doctorData?.serviceShortName
                ? `${servicePrefix || doctorData?.serviceShortName}. `
                : ""}
              {doctorData?.name?.charAt(0).toUpperCase() +
                doctorData?.name?.slice(1)}
            </h4>
            <p
              style={{
                fontSize: "14px",
                color: "#6C757D",
                marginBottom: "8px",
              }}
            >
              {/* {(doctorData.specialty || doctorData.specialization)
                ?.charAt(0)
                .toUpperCase() +
                (doctorData.specialty || doctorData.specialization)?.slice(1)} */}

              {doctorData?.service_name}
            </p>
             <div className="d-flex align-items-center gap-2">
    <span style={{ fontSize: "12px", color: "#6C757D" }}>
    Active
    </span>

    <Form.Check
      type="switch"
      id="crew-status-switch"
      checked={isActive}
      onChange={(e) => handleToggleStatus(e.target.checked)}
    />
  </div>

            <div
              className="d-flex align-items-center gap-4"
              style={{ fontSize: "14px", color: "#6C757D" }}
            >
              {/* Experience */}
              {!isCarService && doctorData?.experience && (
                <div className="d-flex align-items-center gap-2">
                  {/* <RiStethoscopeLine className="fs-5" /> */}
                  <span>
                    {(() => {
                      const exp = doctorData?.experience.trim();
                      if (/experience/i.test(exp)) {
                        return exp.replace(
                          /(experience\s*){2,}/gi,
                          "Experience"
                        );
                      } else {
                        return `${exp} Experience`;
                      }
                    })()}
                  </span>
                </div>
              )}

              {/* Education */}
              {/* <div className="d-flex align-items-center gap-2">
                <RiGraduationCapLine className="fs-5" />
                <span>{doctorData.education}</span>
              </div> */}

              {/* Rating and Edit Button */}
              <div className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center gap-1">
                  <FaStar className="text-warning" />
                  {doctorData?.rating} ({doctorData?.reviews} reviews)
                </span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowEditSidebar(true)}
                  style={{
                    fontSize: "12px",
                    padding: "2px 8px",
                    height: "auto",
                    borderRadius: "4px",
                    marginLeft: "8px",
                  }}
                >
                  Edit profile
                </Button>
              </div>
            </div>

         <div
  className="p-3 mt-2"
  style={{
    border: "1px solid #E3EBF8",
    borderRadius: "12px",
    background: "#FAFBFF",
  }}
>
  {/* Top Row */}
  <div className="d-flex justify-content-between align-items-center">
    <div style={{ fontWeight: 600, fontSize: "14px" }}>
      Availability
    </div>

    <Button
      variant="danger"
      size="sm"
      style={{ borderRadius: "20px", padding: "4px 12px" }}
      onClick={() => {
        setShowCalendar(!showCalendar);

        if (!showCalendar) {
          const today = new Date();

          setHolidayRange([today, null]);

          const selected = formatLocalDate(today);
          fetchCrewBookingsByDate(selected);
        }
      }}
    >
      + Set Holiday
    </Button>
  </div>

  {/* Booking Warning */}
  {crewBookings.length > 0 && (
    <div
      className="mt-3 p-2"
      style={{
        background: "#FFF4F4",
        border: "1px solid #FFD6D6",
        borderRadius: "8px",
      }}
    >
      <div
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "#D32F2F",
          marginBottom: "6px",
        }}
      >
        ⚠ This crew already has bookings on selected Date
      </div>

      {/* Booking Chips */}
      <div className="d-flex flex-wrap gap-2">
        {crewBookings.map((b, i) => (
          <span
            key={i}
            onClick={() =>
              navigate(`/vendor_bookings/${b.display_booking_id}`)
            }
            style={{
              background: "#fff",
              border: "1px solid #E3EBF8",
              borderRadius: "20px",
              padding: "4px 10px",
              fontSize: "12px",
              cursor: "pointer",
              color: "#0d6efd",
              fontWeight: 500,
            }}
          >
            {b.display_booking_id}
          </span>
        ))}
      </div>
    </div>
  )}
</div>
     {showCalendar && (
  <div
    ref={calendarRef}
    className="position-absolute bg-white shadow-lg rounded-3 p-2"
    style={{
      top: "300px",
      right:"0px",
      // left: "45%",
      transform: "translateX(-50%)",
      marginTop: "8px",
      zIndex: 1000,
    }}
  >
    <DatePicker
  selectsRange
  startDate={holidayRange[0]}
  endDate={holidayRange[1]}
  onChange={(dates) => {
  setHolidayRange(dates);

  if (dates[0]) {
    const selected = formatLocalDate(dates[0]);
    fetchCrewBookingsByDate(selected);
  }
}}
  inline
  minDate={new Date()}
  excludeDates={unavailableDatesObj}

  highlightDates={[
    {
      "react-datepicker__day--highlighted-holiday": unavailableDatesObj,
    },
    {
      "react-datepicker__day--highlighted-booking": bookedDates,
    },
  ]}
  // dayClassName={(date) => {
  //   if (
  //     holidayRange[0] &&
  //     !holidayRange[1] &&
  //     date.toDateString() === holidayRange[0].toDateString()
  //   ) {
  //     return "react-datepicker__day--selected-single";
  //   }
  //   return undefined;
  // }}
  dayClassName={(date) => {
  const today = new Date();

  if (
    date.toDateString() === today.toDateString()
  ) {
    return "react-datepicker__day--today-custom";
  }

  if (
    holidayRange[0] &&
    !holidayRange[1] &&
    date.toDateString() === holidayRange[0].toDateString()
  ) {
    return "react-datepicker__day--selected-single";
  }

  return undefined;
}}
/>
    <div className="d-flex justify-content-between mt-2 px-2">
      <Button variant="secondary" size="sm" onClick={() => setShowCalendar(false)}>
        Cancel
      </Button>
      <Button variant="danger" size="sm" onClick={handleSaveHoliday}>
        Save
      </Button>
    </div>
  </div>
)}
          </div>
        </div>
      </div>

      <ProviderAvailability doctorId={doctorData?.id} showBackButton={false} unavailableDates={unavailableDates}/>
<EditProfileSidebar
  show={showEditSidebar}
  onHide={() => setShowEditSidebar(false)}
  userRole={userRole}
  navigate={navigate}
  doctorData ={doctorData}
  setDoctorData={setDoctorData}
  setIndustry={industry}
/>    </div>
  );
};

export default ProviderProfile;
